import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

/**
 * Redirect for old (WordPress) addresses still shown by Google.
 * Uses location.replace so search engines treat it as a permanent move,
 * and marks the old page noindex while it redirects.
 */
export default function LegacyRedirect({ to }: { to: string }) {
  useEffect(() => {
    document.querySelectorAll('meta[name="robots"]:not([data-rh])').forEach((el) => el.remove());
    window.location.replace(to);
  }, [to]);

  return (
    <Helmet>
      <meta name="robots" content="noindex, follow" />
      <link rel="canonical" href={`${window.location.origin}${to}`} />
    </Helmet>
  );
}
